var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":"40","width":"45","src":_vm.render_previewUserGuid()},on:{"click":function($event){return _vm.downloadPdf()}}})}
var staticRenderFns = []

export { render, staticRenderFns }